import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let PiFlexScrollBox = class PiFlexScrollBox extends Vue {
};
PiFlexScrollBox = __decorate([
    Component({
        components: {},
    })
], PiFlexScrollBox);
export default PiFlexScrollBox;
